/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h4: "h4",
    a: "a",
    span: "span",
    blockquote: "blockquote",
    p: "p"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h4, {
    id: "first",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#first",
    "aria-label": "first permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "First"), "\n", React.createElement(_components.blockquote, null, "\n", React.createElement(_components.p, null, "react-native bundle —dev false —platform android —entry-file index.js —bundle-output ./android/app/build/intermediates/assets/debug/index.android.bundle —assets-dest ./android/app/build/intermediates/res/merged/debug"), "\n"), "\n", React.createElement(_components.h4, {
    id: "second",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#second",
    "aria-label": "second permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Second"), "\n", React.createElement(_components.blockquote, null, "\n", React.createElement(_components.p, null, "cd android"), "\n"), "\n", React.createElement(_components.h4, {
    id: "final",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#final",
    "aria-label": "final permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Final"), "\n", React.createElement(_components.blockquote, null, "\n", React.createElement(_components.p, null, "./gradlew assembleDebug"), "\n"), "\n", React.createElement(_components.p, null, "Once all three commands executed successfully. You can find the generated APK on"), "\n", React.createElement(_components.blockquote, null, "\n", React.createElement(_components.p, null, "Project root directory > android > app > build > outputs > apk > app-debug.apk"), "\n"), "\n", React.createElement(_components.p, null, "As the name suggests, this is not a release version. But still, you can share it with testers. I use ", React.createElement(_components.a, {
    href: "http://hockeyapp.net",
    target: "_blank",
    rel: "nofollow noopener"
  }, "hockeyapp"), " to do the distribution."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
